<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path d="M29.3 4.45a2.38 2.38 0 0 0-3.36 0L10.79 19.6l-6.73-6.73A2.38 2.38 0 1 0 .7 16.23l8.41 8.42a2.37 2.37 0 0 0 3.37 0L29.3 7.81c.93-.92.93-2.43 0-3.36Z" fill="currentColor" />
  </svg>
</template>
